import React from 'react';

const FeatureCard = ({ icon: Icon, title, description }) => {
	return (
		<div className="bg-white rounded-xl p-6 shadow-md border border-gray-100 hover:shadow-xl hover:-translate-y-1 transition-all duration-300">
			<div className="w-12 h-12 rounded-lg bg-blue-100 text-blue-600 flex items-center justify-center mb-4">
				<Icon className="w-6 h-6" />
			</div>
			<h3 className="text-lg font-bold text-gray-900 mb-2">{title}</h3>
			<p className="text-gray-600">{description}</p>
		</div>
	);
};

export default FeatureCard;


